import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IExcelFile, defaultValue } from 'app/shared/model/excel-file.model';

export const ACTION_TYPES = {
  FETCH_EXCELFILE_LIST: 'excelFile/FETCH_EXCELFILE_LIST',
  FETCH_EXCELFILE: 'excelFile/FETCH_EXCELFILE',
  CREATE_EXCELFILE: 'excelFile/CREATE_EXCELFILE',
  UPDATE_EXCELFILE: 'excelFile/UPDATE_EXCELFILE',
  DELETE_EXCELFILE: 'excelFile/DELETE_EXCELFILE',
  SET_BLOB: 'excelFile/SET_BLOB',
  RESET: 'excelFile/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IExcelFile>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type ExcelFileState = Readonly<typeof initialState>;

// Reducer

export default (state: ExcelFileState = initialState, action): ExcelFileState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_EXCELFILE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_EXCELFILE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_EXCELFILE):
    case REQUEST(ACTION_TYPES.UPDATE_EXCELFILE):
    case REQUEST(ACTION_TYPES.DELETE_EXCELFILE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_EXCELFILE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_EXCELFILE):
    case FAILURE(ACTION_TYPES.CREATE_EXCELFILE):
    case FAILURE(ACTION_TYPES.UPDATE_EXCELFILE):
    case FAILURE(ACTION_TYPES.DELETE_EXCELFILE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_EXCELFILE_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_EXCELFILE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_EXCELFILE):
    case SUCCESS(ACTION_TYPES.UPDATE_EXCELFILE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_EXCELFILE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.SET_BLOB: {
      const { name, data, contentType } = action.payload;
      return {
        ...state,
        entity: {
          ...state.entity,
          [name]: data,
          [name + 'ContentType']: contentType,
        },
      };
    }
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/excel-files';

// Actions

export const getEntities: ICrudGetAllAction<IExcelFile> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_EXCELFILE_LIST,
  payload: axios.get<IExcelFile>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IExcelFile> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_EXCELFILE,
    payload: axios.get<IExcelFile>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IExcelFile> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_EXCELFILE,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IExcelFile> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_EXCELFILE,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IExcelFile> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_EXCELFILE,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const setBlob = (name, data, contentType?) => ({
  type: ACTION_TYPES.SET_BLOB,
  payload: {
    name,
    data,
    contentType,
  },
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
